import { useState } from 'react';

import CallOut from '@Components/CallOut/Callout';
import ChevronIcon from '@Components/Icons/Chevron';

export interface InfoNoteProps {
    note: string;
    expandedNote?: string;
}

export const InfoNote = ({ note, expandedNote }: InfoNoteProps) => {
    const [learnMore, setLearnMore] = useState(false);

    const handleToggle = () => {
        setLearnMore((prev) => !prev);
    };

    if (!expandedNote) {
        return (
            <CallOut classes='mb-4 text-sm items-center'>
                <div className='leading-120%'>
                    <p>{note}</p>
                </div>
            </CallOut>
        );
    }

    return (
        <CallOut classes='mb-4'>
            <div className='leading-120%'>
                <p className='text-sm'>{note}</p>
                {learnMore && (
                    <p className='text-sm swhitespace-pre-line'>
                        {expandedNote}
                    </p>
                )}

                <div
                    onClick={handleToggle}
                    className='mt-3 w-24 text-xs font-bold justify-center bg-monochrome-100 items-center flex rounded-2xl cursor-pointer'
                >
                    <span className='pr-1'>
                        {learnMore ? 'Close' : 'Read more'}
                    </span>
                    <ChevronIcon
                        isRotated={learnMore}
                        height='12px'
                        width='12px'
                        color='#3A4146'
                    />
                </div>
            </div>
        </CallOut>
    );
};
